import { render, staticRenderFns } from "./toBindManagementNumber.vue?vue&type=template&id=b5ccf284&scoped=true&"
import script from "./toBindManagementNumber.vue?vue&type=script&lang=js&"
export * from "./toBindManagementNumber.vue?vue&type=script&lang=js&"
import style0 from "./toBindManagementNumber.vue?vue&type=style&index=0&id=b5ccf284&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ccf284",
  null
  
)

export default component.exports